import React from 'react';
import { useTranslation } from 'react-i18next';

import LockedReward from '../../../../assets/images/LockedReward.png';
import ButtonWithIcon from '../../../../components/shared/ButtonWithIcon/ButtonWithIcon';
import baseServerUrl from '../../../../services/apiServer';

import styles from './UnlockReferralRewards.module.scss';

const UnlockReferralRewards = () => {
  const { t } = useTranslation('common');
  return (
    <div className={styles.mainContainer}>
      <div className={styles.rewardContainer}>
        <img src={LockedReward} alt="reward" className={styles.rewardIcon} />
        <div className={styles.detailContainer}>
          <span className={styles.rewardHeading}>{t('browse.signUpToUnlock')}</span>
          <span className={styles.rewardText}>{t('browse.dontMissOut')}</span>
        </div>
      </div>
      <ButtonWithIcon
        text={t('buttons.signupNow')}
        className={styles.buttonSignUp}
        textClassName="btn-icon-text-primary-40"
        variant="primary-36"
        onClick={() => {
          window.location.href = `${baseServerUrl}/login`;
        }}
      />
    </div>
  );
};

export default UnlockReferralRewards;
